import Button from "@/components/Button/Button";
import styles from "./NoDataFound.module.scss";
import NoData from "@/components/SVGComponents/NoData";

interface NoDataFoundProps {
  itemName?: string;
  onClick?: () => void;
  showAddAction?: boolean;
}

const NoDataFound = ({ itemName, onClick, showAddAction = false }: NoDataFoundProps) => {
  return (
    <div className={styles.container}>
      <NoData />

      {showAddAction ? (
        <>
          <p className={styles.noDataText}>No {itemName} added yet.</p>
          <p className={styles.context}>Add a {itemName} and kickstart operations</p>
          <Button type="button" onClick={onClick} className={styles.addButton}>
            Add {itemName}
          </Button>
        </>
      ) : (
        <p className={styles.noDataText}>No Data Available.</p>
      )}
    </div>
  );
};

export default NoDataFound;
